import routes from '@/modules/decision-target/decision-target-routes';
import store from '@/modules/decision-target/decision-target-store';

export default {
    routes,
    store,
}
